import { ArrowDownRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=2400&q=90";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative border-b border-neutral-200 grain-bg"
    >
      <div className="mx-auto max-w-[1400px] grid grid-cols-12 gap-0">
        {/* Left massive headline */}
        <div className="col-span-12 lg:col-span-8 px-4 md:px-8 pt-16 md:pt-28 pb-12 md:pb-20 lg:border-r border-neutral-200">
          <div className="flex items-center gap-3 mb-8">
            <span className="font-mono-tech text-xs tracking-[0.2em] uppercase text-neutral-500">
              [01] Datavex / Est. 2017
            </span>
            <span className="h-px flex-1 bg-neutral-200" />
            <span className="font-mono-tech text-xs tracking-[0.2em] uppercase text-neutral-500">
              B2B · B2G
            </span>
          </div>

          <h1
            data-testid="hero-heading"
            className="font-display font-black tracking-tighter text-[44px] sm:text-7xl lg:text-[112px] leading-[0.9]"
          >
            Decisions,
            <br />
            <span className="text-neutral-400">engineered from</span>
            <br />
            data<span className="text-[#FF3300]">.</span>
          </h1>

          <p className="mt-8 max-w-2xl text-base md:text-lg text-neutral-700 leading-relaxed">
            We build the analytics infrastructure that enterprises and government agencies use to
            deploy capital, allocate resources, and prove outcomes — backed by audit-grade
            engineering and 200+ shipped engagements.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-primary-cta"
              className="group inline-flex items-center gap-3 px-6 h-12 bg-[#002FA7] text-white text-sm font-semibold hover:bg-black transition-colors"
            >
              Start an engagement
              <ArrowDownRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:translate-y-0.5" />
            </a>
            <a
              href="#cases"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center gap-3 px-6 h-12 border border-black text-black text-sm font-semibold hover:bg-black hover:text-white transition-colors"
            >
              See case studies
            </a>
          </div>
        </div>

        {/* Right: image stack */}
        <div className="col-span-12 lg:col-span-4 relative min-h-[280px] lg:min-h-[640px] grid grid-rows-5">
          <div className="row-span-3 border-b border-neutral-200 overflow-hidden">
            <img
              src={HERO_IMG}
              alt="Abstract data visualization"
              className="w-full h-full object-cover"
              data-testid="hero-image"
            />
          </div>
          <div className="row-span-2 grid grid-cols-2">
            <div className="border-r border-neutral-200 p-5 flex flex-col justify-between">
              <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-500">
                Active engagements
              </span>
              <div>
                <div className="font-display text-5xl font-black">42</div>
                <div className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-500 mt-1">
                  across 11 sectors
                </div>
              </div>
            </div>
            <div className="p-5 flex flex-col justify-between bg-neutral-950 text-white">
              <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-400">
                Data points / day
              </span>
              <div>
                <div className="font-display text-5xl font-black">3.1B</div>
                <div className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-neutral-400 mt-1">
                  processed for clients
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
